<button class="svg-icon-btn" (click)="onClick($event)" [ngClass]="getButtonClasses()" [attr.active]="selected">
  <div class="svg-icon-btn-container">
    <span *ngIf="svg && svg.length" class="btn-svg-icon" [innerHtml]="svg | safeHtml"></span>
    <div class="button-text text-truncate">{{ text }}</div>
  </div>
</button>
